// extracted by mini-css-extract-plugin
export default {"branchArrow":"BranchArrowButton__branchArrow___l1soB","branchArrowCollapsed":"BranchArrowButton__branchArrowCollapsed___kibTT BranchArrowButton__branchArrow___l1soB"};